import React, { createContext, useContext, useState, useCallback } from "react";

const ContactCtx = createContext(null);

export const ContactProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState(null); // {ref,name}

  const openContact = useCallback((prod = null) => {
    setProduct(prod);
    setOpen(true);
  }, []);

  return (
    <ContactCtx.Provider value={{ open, setOpen, product, openContact }}>
      {children}
    </ContactCtx.Provider>
  );
};

export const useContact = () => {
  const ctx = useContext(ContactCtx);
  if (!ctx) throw new Error("useContact within ContactProvider");
  return ctx;
};
